// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___2ZQ2d","content":"styles__content___2ZusG","icon":"styles__icon___3uzRv","text":"styles__text___3o_Qz","button":"styles__button___H0dqY"};